import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import {
  CreateOrUpdateJobCommentRequest,
  HttpResponse,
  JobComment,
} from "@/types";

export function useUpdateJobComment() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({
      jobCommentId,
      updateJobCommentRequest,
    }: {
      jobCommentId: number;
      updateJobCommentRequest: CreateOrUpdateJobCommentRequest;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/job-comments/${jobCommentId.toString()}`;
      const res = await guacHttpClient.patch<
        JobComment,
        HttpResponse<JobComment>,
        CreateOrUpdateJobCommentRequest
      >(path, updateJobCommentRequest);

      return res.data;
    },
  });

  return mutation;
}
